import { render, staticRenderFns } from "./CreateComponentView.vue?vue&type=template&id=58b78a69&scoped=true"
import script from "./CreateComponentView.vue?vue&type=script&lang=js"
export * from "./CreateComponentView.vue?vue&type=script&lang=js"
import style0 from "./CreateComponentView.vue?vue&type=style&index=0&id=58b78a69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b78a69",
  null
  
)

export default component.exports